export default "__VITE_ASSET__63873dc6__"